import moment from "moment";
import SelectCodeMasterCategoryComponent from "../../../components/code-master/select-code-master-category.component";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../../components/site/select-site-search-input.component";
import { codeMasterType, formats } from "../../../config/constants";
import languageModel from "../../../models/language.model";
import SAVINADirectInterfaceModel from "../../../models/reports/sms/savina-direct-interface.model";
import ViewBase from "../../view-base.view";


export default function SAVINADirectInterfaceView() {
  ViewBase.call(this);

  const DEFAULT_PAGINATION = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0
  }

  const DEFAULT_FILTERS = {
    fromDate: '',
    toDate: '',
    sites: [],
    status: '',
    senderNo: '',
    recipientNo: '',
    imeiSerialNo: '',
    vendor: '',
    type: '',
  }

  const DEFAULT_TYPES = [
    { code: 'R', name: 'IMEI' },
    { code: 'S', name: 'Serial No' },
  ]

  let filters = {};
  let pagination = {};
  let currentFilters = {};

  let listLogs = [];
  let listVendorOptions = [];
  let errorMessage = ''

  const toParams = (filters) => {
    return Object.assign({
      siteIds: filters.sites?.map((item) => item.siteId),
      status: filters.status.length > 0 ? filters.status : '',
      type: filters.type.length > 0 ? filters.type : '',
      vendorCode: filters.vendor.length > 0 ? filters.vendor : '',
      senderNo: filters.senderNo,
      recipientNo: filters.recipientNo,
      imeiOrSerialNo: filters.imeiSerialNo,
      datefrom: moment(filters.fromDate).format(formats.dateFormat),
      dateTo: moment(filters.toDate).format(formats.dateFormat),
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    })
  }

  const compare = (a, b) => {
    return a.no < b.no ? -1 : a.no === b.no ? 0 : 1;
  }

  const search = (params) => {
    this.showLoading();

    SAVINADirectInterfaceModel.search(params)
      .then((result) => {
        listLogs = result.data || [];
        listLogs.sort(compare);
        pagination.totalItems = result.total;
      })
      .catch((error) => {
        listLogs.splice(0);
        this.handleError(error);
      })
      .finally(() => { this.hideLoading(); })
  }

  const handleSearch = (e) => {
    e.preventDefault();
    pagination.pageIndex = DEFAULT_PAGINATION.pageIndex;
    currentFilters = structuredClone(filters);
    let params = toParams(currentFilters);
    search(params);
  }

  const clearFilter = () => {
    initialData();
  }

  const onPageSizeChanged = (pageIndex, pageSize) => {
    pagination.pageIndex = pageIndex;
    pagination.pageSize = pageSize;
    let params = toParams(currentFilters);
    search(params);
  };

  const onPageChanged = (pageIndex) => {
    pagination.pageIndex = pageIndex;
    let params = toParams(currentFilters);
    search(params);
  };

  const downloadExcel = (params) => {
    this.showLoading();
    SAVINADirectInterfaceModel.downloadExcel(params)
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() })
  }

  const handleDownloadExcel = () => {
    let params = toParams(currentFilters);
    downloadExcel(params);
  }

  const getListVendor = () => {
    SAVINADirectInterfaceModel.getListVendor()
      .then((result) => {
        listVendorOptions = result || [];
      })
      .catch((error) => { this.handleError(error) })
  }

  const initialData = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    filters.fromDate = moment(new Date()).format(formats.dateFormat);
    filters.toDate = moment(new Date()).format(formats.dateFormat);
    filters.type = DEFAULT_TYPES[0].code;
  }

  return {
    oninit: () => {
      pagination = structuredClone(DEFAULT_PAGINATION);
      initialData();
      getListVendor();
    },
    view: () => {
      return [
        /** SEARCH SECTION */
        m('.card.mb-3',
          m('.card-body',
            m('form.row.g-2',
              { onsubmit: handleSearch },
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="period"]', this.getText('LT00000150', 'Period')),
                m(DatePickerComponent, {
                  id: 'period',
                  class: 'form-control',
                  placeholder: this.getText('LT00000070', 'Date Range'),
                  isRange: true,
                  readonly: true,
                  dateStart: filters.fromDate,
                  dateEnd: filters.toDate,
                  onselect: (event) => {
                    filters.fromDate = event.detail.start;
                    filters.toDate = event.detail.end;
                  }
                }),
                m('.invalid-tooltip', errorMessage)
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="sites"]', this.getText('LT00000516', 'Site(s)')),
                m(SelectSiteSearchInputComponent, {
                  id: 'sites',
                  multiple: true,
                  selectedItems: filters.sites,
                  onSelect: (selectedItems) => {
                    filters.sites = selectedItems;
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="status"]', this.getText('LT00000781', 'Status')),
                m(SelectCodeMasterCategoryComponent, {
                  category: codeMasterType.smsVnIntfStatus,
                  isMultiple: false,
                  id: 'status',
                  selectedItem: filters.status,
                  keyOnly: true,
                  onSelect: (selectedItem) => {
                    filters.status = selectedItem;
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="senderNo"]', this.getText('LT00001085', "Sender's No.")),
                m('input#senderNo', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00001085', "Sender's No."),
                  type: 'text',
                  value: filters.senderNo,
                  onchange: (e) => { filters.senderNo = e.target.value }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="recipientNo"]', this.getText('LT00001086', 'Recipient"s No.')),
                m('input#recipientNo', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00001086', 'Recipient"s No.'),
                  type: 'text',
                  value: filters.recipientNo,
                  onchange: (e) => { filters.recipientNo = e.target.value }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="type"]', this.getText('LT00000117', 'Type')),
                m(SelectCodeMasterCategoryComponent, {
                  category: codeMasterType.smsVnIntfType,
                  isMultiple: false,
                  id: 'type',
                  allowEmpty: false,
                  selectedItem: filters.type,
                  keyOnly: true,
                  onSelect: (selectedItem) => {
                    filters.type = selectedItem;
                  }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="imeiSerialNo"]', this.getText('LT00001087', 'IMEI / Serial No.')),
                m('input#imeiSerialNo', {
                  class: 'form-control form-control-bg',
                  placeholder: this.getText('LT00001087', 'IMEI / Serial No.'),
                  type: 'text',
                  value: filters.imeiSerialNo,
                  onchange: (e) => { filters.imeiSerialNo = e.target.value }
                })
              ),
              m('.col-md-3.col-lg-3.position-relative',
                m('label.form-label[for="vendor"]', this.getText('LT00001088', 'Vendor')),
                m(SingleSelectComponent, {
                  id: 'vendor',
                  items: listVendorOptions,
                  selectedItem: filters.vendor,
                  keyOnly: true,
                  onSelect: (selectedItem) => {
                    filters.vendor = selectedItem;
                  }
                })
              ),
              m('.col-12.d-flex.justify-content-end.gap-2',
                m('button.btn.btn-primary', this.getText("LT00000001", "Search")),
                m('button.btn.btn-white[type=button]', { onclick: clearFilter }, this.getText("LT00000031", "Clear"))
              )
            )
          )
        ),

        /* TABLE */
        m('.card',
          m('.card-body',
            m('.row.g-2',
              m('.col-12.d-flex.justify-content-end',
                m('button.btn.btn-primary', {
                  onclick: handleDownloadExcel,
                  disabled: !(listLogs.length > 0),
                },
                  m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText("LT00000018", "Excel Download"))
              ),
              m('.col-12',
                m('.table-responsive',
                  m('table.table',
                    m('thead',
                      m('tr.align-middle',
                        m('th', this.getText('LT00000721', 'No.')),
                        m('th', this.getText('LT00001089', 'Received Date')),
                        m('th', this.getText('LT00001085', "Sender's No.")),
                        m('th', this.getText('LT00001090', 'Sale Date')),
                        m('th', this.getText('LT00001087', 'IMEI / Serial No.')),
                        m('th', this.getText('LT00001086', "Recipient's No.")),
                        m('th', this.getText('LT00001091', 'Replied Message')),
                        m('th', this.getText('LT00001092', 'Replied Date')),
                      )
                    ),
                    m('tbody',
                      listLogs.length == 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td", { colspan: 8 }, languageModel.getText("EM00000141", "No records found."))
                      ),

                      listLogs.length > 0 &&
                      listLogs.map((row) => {
                        return m('tr.align-middle',
                          m('td', m('span.cursor-text', row.no)),
                          m('td', m('span.cursor-text', moment(row.receivedDate).format(formats.LOCAL_TIME))),
                          m('td', m('span.cursor-text', row.senderNo)),
                          m('td', m('span.cursor-text', moment(row.saleDate).format(formats.apiDateFormat))),
                          m('td', m('span.cursor-text', row.imeiOrSerialNo)),
                          m('td', m('span.cursor-text', row.recipientNo)),
                          m('td', m('span.cursor-text.text-wrap', row.repliedMessage)),
                          m('td', m('span.cursor-text', row.repliedDate)),
                        );
                      })
                    )
                  )
                )
              )
            ),
            listLogs.length > 0 &&
            m('.col-12', m(paginationComponent,
              {
                currentPage: pagination.pageIndex,
                pageSize: pagination.pageSize,
                totalItems: pagination.totalItems,
                onPageChanged: onPageChanged,
                onPageSizeChanged: onPageSizeChanged,
              }
            ))
          )
        ),

        this.getBaseViews()
      ]
    }
  }
}